// Shared React Select styling for Form V2 and matching application controls.
const SPRING_PURPLE = "#7e57c2";
const SPRING_PURPLE_DARK = "#6847a3";

export const formV2SelectStyles = {
  menuPortal: (base: any) => ({ ...base, zIndex: 99999 }),
  control: (base: any, state: any) => ({
    ...base,
    minHeight: "var(--waivera-control-height, 52px)",
    height: "auto",
    backgroundColor: state.isDisabled ? "var(--forms-v2-select-disabled, #f3f4f6)" : "var(--forms-v2-select-surface, #ffffff)",
    borderColor: state.isFocused ? SPRING_PURPLE : "var(--forms-v2-select-border, #d1d5db)",
    borderWidth: "1px",
    borderRadius: "0.5rem",
    boxShadow: state.isFocused ? "0 0 0 2px rgba(126, 87, 194, 0.18)" : "none",
    cursor: state.isDisabled ? "not-allowed" : "default",
    "&:hover": {
      borderColor: state.isFocused ? SPRING_PURPLE : "var(--forms-v2-select-border-hover, #a78bca)",
    },
  }),
  valueContainer: (base: any) => ({
    ...base,
    minHeight: "var(--waivera-control-value-height, 50px)",
    maxHeight: "var(--waivera-control-value-max-height, 100px)",
    padding: "var(--waivera-control-value-padding, 8px 14px)",
    overflowY: "auto",
    alignContent: "center",
  }),
  placeholder: (base: any) => ({
    ...base,
    margin: 0,
    color: "var(--forms-v2-select-muted, #9ca3af)",
    lineHeight: 1.35,
    whiteSpace: "normal",
    overflow: "visible",
    textOverflow: "clip",
  }),
  singleValue: (base: any) => ({
    ...base,
    margin: 0,
    color: "var(--forms-v2-select-text, #374151)",
    lineHeight: 1.35,
    whiteSpace: "normal",
    overflow: "visible",
    textOverflow: "clip",
  }),
  input: (base: any) => ({
    ...base,
    margin: 0,
    padding: 0,
    color: "var(--forms-v2-select-text, #374151)",
    lineHeight: 1.35,
    border: "0",
    outline: "none",
    boxShadow: "none",
    backgroundColor: "transparent",
  }),
  menu: (base: any) => ({
    ...base,
    borderRadius: "0.625rem",
    overflow: "hidden",
    border: "1px solid var(--forms-v2-select-border, #e5e7eb)",
    backgroundColor: "var(--forms-v2-select-surface, #ffffff)",
    boxShadow: "var(--forms-v2-select-shadow, 0 10px 25px rgba(17, 24, 39, 0.12))",
  }),
  menuList: (base: any) => ({
    ...base,
    padding: "4px",
  }),
  option: (base: any, state: any) => ({
    ...base,
    border: "none",
    boxShadow: "none",
    borderRadius: "0.375rem",
    padding: "8px 12px",
    minHeight: "36px",
    display: "flex",
    alignItems: "center",
    lineHeight: "20px",
    cursor: state.isDisabled ? "not-allowed" : "pointer",
    color: state.isDisabled ? "var(--forms-v2-select-muted, #6b7280)" : "var(--forms-v2-select-text, #374151)",
    backgroundColor: state.isSelected
      ? "var(--forms-v2-select-option-selected, rgba(126, 87, 194, 0.14))"
      : state.isFocused
        ? "var(--forms-v2-select-option-hover, rgba(126, 87, 194, 0.09))"
        : "var(--forms-v2-select-surface, #ffffff)",
    "&:active": {
      backgroundColor: state.isSelected
        ? "var(--forms-v2-select-option-selected, rgba(126, 87, 194, 0.14))"
        : "var(--forms-v2-select-option-hover, rgba(126, 87, 194, 0.09))",
    },
  }),
  multiValue: (base: any) => ({
    ...base,
    borderRadius: "0.375rem",
    backgroundColor: "var(--forms-v2-select-chip, rgba(126, 87, 194, 0.10))",
  }),
  multiValueLabel: (base: any) => ({
    ...base,
    color: "var(--forms-v2-select-chip-text, #6847a3)",
    fontWeight: 600,
  }),
  multiValueRemove: (base: any) => ({
    ...base,
    color: SPRING_PURPLE,
    borderRadius: "0 0.375rem 0.375rem 0",
    "&:hover": {
      color: "#ffffff",
      backgroundColor: SPRING_PURPLE,
    },
  }),
  indicatorSeparator: (base: any) => ({
    ...base,
    backgroundColor: "var(--forms-v2-select-border, #e5e7eb)",
  }),
  dropdownIndicator: (base: any, state: any) => ({
    ...base,
    padding: "0 12px",
    color: state.isFocused ? SPRING_PURPLE : "var(--forms-v2-select-muted, #9ca3af)",
    "&:hover": { color: SPRING_PURPLE },
  }),
  clearIndicator: (base: any) => ({
    ...base,
    padding: "0 6px",
    color: "var(--forms-v2-select-muted, #9ca3af)",
    "&:hover": { color: SPRING_PURPLE_DARK },
  }),
};

// Opt in for compact admin controls. Existing FormsV2 defaults stay at 52px.
// Minimum heights allow wrapped labels and multi-select chips to grow naturally.
export const compactFormV2SelectStyles = {
  ...formV2SelectStyles,
  control: (base: any, state: any) => ({
    ...formV2SelectStyles.control(base, state),
    minHeight: "40px",
    fontSize: "14px",
    padding: 0,
  }),
  valueContainer: (base: any) => ({
    ...formV2SelectStyles.valueContainer(base),
    minHeight: "38px",
    maxHeight: "none",
    padding: "4px 12px",
    overflowY: "visible",
    alignItems: "center",
    lineHeight: "22px",
  }),
};

